import { useEffect } from 'react';

import { publicEnv } from '~/features/environment/public';
import { fetchLiveBuildSha, shouldReloadForNewDeploy } from '~/utils/check-deployment-version';

const loadedSha = publicEnv.NEXT_PUBLIC_BUILD_SHA;
const isTestEnvironment = publicEnv.NEXT_PUBLIC_ENVIRONMENT_NAME === 'test';
/**
 * Reloads the page when a newer deploy is live so long-lived SPA tabs pick up fresh JS and content.
 * Checks on mount.
 */
export function useDeploymentVersionCheck() {
  useEffect(() => {
    if (!loadedSha || isTestEnvironment) {
      return;
    }

    const buildShaAtLoad: string = loadedSha;

    function reloadPage() {
      window.location.reload();
    }

    async function checkForNewDeploy() {
      const liveSha = await fetchLiveBuildSha();
      if (shouldReloadForNewDeploy(buildShaAtLoad, liveSha)) {
        reloadPage();
      }
    }

    checkForNewDeploy();
  }, []);
}
